import React, { useEffect, useState, useMemo } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { BsCash } from "react-icons/bs";
import defaultMiniature from "assets/images/curved-images/digitization.png";
import PropTypes from "prop-types";
import SoftButton from "../../../components/SoftBox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { MdDelete, MdEdit, MdRefresh, MdMoreVert } from "react-icons/md";
import DeleteArticleDialog from "../../../layouts/publications/DeleteArticleDialog";
import { useSoftUIController } from "../../../context";
import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
import Highlighter from "react-highlight-words";
import { io } from 'socket.io-client';
import { SUPER_ADMIN_ROLE, FREE_AGENT } from "../../../utlis/constant";
import { format } from 'date-fns';
import {
    captureOrder,
    createOrder,
    deleteSelectedServiceProcess,
    downloadAudio,
    rerunDigitizer,
    rerunService,
    skipService
} from "../../../axios-client";
import CancelIcon from '@mui/icons-material/Cancel';
import { getStatusIcon } from "../../../utlis/generalUtils";
import StepperStatusComponent from "../../../components/Steper/StepperStatusComponent";
import EditDigitizedArticleDialog from "../../../layouts/publications/EditDigitizedArticleDialog";
import { openTheEditor } from "../../../mainComponents/payment/helper";
import api from "assets/images/apiRed.png";
import CreditCardPaymentButton from "../../payment/CreditCardPaymentButton";
import CreditsPaymentButton from "../../payment/CreditsPaymentButton";
import { MdStarRate } from "react-icons/md";
import FeedbackDialog from "../../Feedback/FeedbackDialog";
import Typography from "@mui/material/Typography";

import {
    useMediaQuery, useTheme, Menu, MenuItem, Chip, Button, Box,
    Stack,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import ServicesIconsGroup from "../../ServicesIcons/ServicesIconsGroup";
import MyTimer from "../../../reusableComponents/Timer/MyTimer";
import { useTranslation } from "react-i18next";
import { TiWarning } from "react-icons/ti";
import Divider from "@mui/material/Divider";
import {Close, Description, Edit, Feedback, Language, MoreVert, Print, Refresh, VolumeUp,  CreditCard,
    CheckCircle,Info, List, Timer, Delete,
    Download,
    Settings,} from "@mui/icons-material";
import RunNonExecutedServices from "../../../layouts/publications/RunNonExecutedServices";

const CardItem = ({
                id,
                title,
                image,
                author,
                sourceLanguage,
                targetLanguage,
                publishedAt,
                summary,
                services_data,
                createdAt,
                status,
                origin,
                handleClickDownloadDigitizedDocument,
                handleOpenPreview,
                subjects,
                setNotification,
                articleId,
                cost,
                userCreditBalance,
                searchText,
                refreshList,
                paymentStatus,
                freeAgentDocuments = false,
                digitizerId,
                all_services_selected,
                feedback_rating,
                totalApproximativeTime,
                digitizationStartedAt,
                digitizationProcesses,
                pendingProcessesCost,
                CompletedProcessesCost,
}) => {
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [controller, dispatch] = useSoftUIController();
    const { t, i18n } = useTranslation(['cardItem']);
    const lang = i18n.language;
    const dir = i18n.dir();
    const [isRunNonExecutedServicesButtonEnabled, setIsRunNonExecutedServicesButtonEnabled] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false)

    const updated_services_data =  services_data?.map((service) => {
    if (service.service_name === "OCR" && service.service_status === "PENDING") {
      return { ...service, service_status: "IN_PROGRESS" };
    }
    return service;

  });

    const stripePublicKey = window?.appConfig?.REACT_APP_STRIPE_PUBLIC_KEY || process.env.REACT_APP_STRIPE_PUBLIC_KEY;
    const activeCreditCard = stripePublicKey != "";
    const [stepsData, setStepsData] = useState(updated_services_data);
    const [digitizationFailed, setDigitizationFailed] = useState(status === "ERROR" ? true : false);
    const [rerunDigitization, setRerunDigitization] = useState(false);
    const [isMetadataDialogOpen, setMetadataDialogOpen] = useState(false);
    const [openRunNonExecutedServicesDialog, setOpenRunNonExecutedServicesDialog] = useState(false);
    const [hasSufficientCredits, setHasSufficientCredits] = useState(false);
    const [approximateEndTime, setApproximateEndTime] = useState(null);
    const [pendingServices, setPendingServices] = useState([]);
    const processIds = digitizationProcesses.map(p => p.id);
    const pendingProcessIds = digitizationProcesses?.filter(process => process.digitization_status === "PENDING").map(process => process.id);
    const hasPendingProcess = digitizationProcesses.some(p => p.digitization_status === "PENDING");

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [actionMenuAnchor, setActionMenuAnchor] = useState(null);

    useEffect(() => {
        if (digitizationProcesses && digitizationProcesses.length > 0) {
            const servicesWithPending = digitizationProcesses
                .filter(p => p.digitization_status === "PENDING")
                .flatMap(p => p.services || [])

            setPendingServices(servicesWithPending);
        }
    }, [digitizationProcesses, lang]);

    useEffect(() => {
        if (status === "COMPLETE" && !stepsData?.some(service => service.service_status === "IN_PROGRESS" )) {
            setIsRunNonExecutedServicesButtonEnabled(true);
        } else {
            setIsRunNonExecutedServicesButtonEnabled(false);
        }
    }, [status, stepsData]);

    const isOCRCompleted = useMemo(() => {
        return stepsData?.some(
            (service) =>
            service.service_name === "OCR" &&
            service.service_status === "COMPLETED"
        );
    }, [stepsData]);

    useEffect(() => {
        if (userCreditBalance > 0 && userCreditBalance >= cost) {
            setHasSufficientCredits(true);
        } else {
            setHasSufficientCredits(false);
        }

    }, [userCreditBalance, cost]);

    useEffect(() => {

        if((status == "COMPLETE" && stepsData?.some(service => service.service_status === 'ERROR' || service.service_status === 'IN_PROGRESS')) ||
            (status != "COMPLETE" && status != "ERROR" && status != "PENDING") || (rerunDigitization === true )){
            const baseURL = window?.appConfig?.REACT_APP_SOCKET_SERVER || process.env.REACT_APP_SOCKET_SERVER
            const socket = io(baseURL, {
                path: "/socket.io"
            });
        const eventName = `digitization_status_update-${id}`;
        socket.on(eventName, (res) => {
                setStepsData(res.data)
            if (res.status === 'COMPLETE') {
            socket.off(`digitization_status_update-${id}`);
                    setRerunDigitization(false)
                    refreshList()
            } else if (res.status === 'ERROR') {
                    setDigitizationFailed(true)
                    setRerunDigitization(false)
                    refreshList()
            }
        });

        const startAt = digitizationStartedAt ? new Date(digitizationStartedAt) : new Date();
        const approximateEndTime = new Date(startAt.getTime() + totalApproximativeTime * 1000);
        setApproximateEndTime(approximateEndTime);

        return () => {
            socket.off(`digitization_status_update-${id}`);
        };
        }
    }, [rerunDigitization, id, refreshList, status, stepsData, digitizationStartedAt, totalApproximativeTime]);

    const handleOpenMetadataDialog = () => {
        setMetadataDialogOpen(true);
    };

    const handleCloseMetadataDialog = () => {
        setMetadataDialogOpen(false);
    };

    const handleRerunDigitization = () => {
        setDigitizationFailed(false)
        setRerunDigitization(true)
        rerunDigitizer(id, {digitization_process_ids: processIds}).then((res) => {
        setNotification({ show: true, snackbarMessage: t("digitizationRerunSuccess"), severity: "success" });
        refreshList()
        }).catch((error) => {
        setNotification({ show: true, snackbarMessage: t("genericError"), severity: "error" });
        })
    };

    const handleOpenDeleteDialog = () => {
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
    };

    const formattedCreatedAt = createdAt ? format(new Date(createdAt), 'MMM dd, yyyy hh:mm a') : '';

    const handleRerunService = (serviceName) => {
        rerunService(id, {service_name: serviceName.service_name, digitization_process_ids: processIds})
        .then(() => {})
        .catch(e => {
            setNotification({ show: true, snackbarMessage: t("genericError"), severity: "error" });
        })
    }

    const handleSkipService = (serviceName) => {
        skipService(id, serviceName)
        .then((res) => {
            setStepsData(res.data.services)
        })
        .catch(e => {
            setNotification({ show: true, snackbarMessage: t("genericError"), severity: "error" });
        })
    }

    const handleActionMenuOpen = (event) => setActionMenuAnchor(event.currentTarget);
    const handleActionMenuClose = () => setActionMenuAnchor(null);

    const handleDeletePendingService = async (serviceId) => {
        try {
            const response = await deleteSelectedServiceProcess(id, serviceId)

            setNotification({
                show: true,
                snackbarMessage: response.data.message || "Pending service deleted",
                severity: "success",
            });

            refreshList();

        } catch (error) {
            console.error("Error deleting pending service:", error);
            setNotification({
                show: true,
                snackbarMessage: error.response?.data?.error || "Error deleting service",
                severity: "error",
            });
        }
    };

    return (
        <Card
        sx={{
            position: "relative",
            overflow: "visible",
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(16px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: 1.5,
            boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
            transform: "translateY(-4px)",
            borderColor: "rgba(255, 255, 255, 0.3)",
            background: "rgba(255, 255, 255, 0.15)",
            boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.35)",
            "& .desktop-action-buttons": {
                opacity: 1,
            },
            },
        }}
        >
        {/* Header Section with glass effect */}
        <Box
            sx={{
            position: "relative",
            background: "rgba(241, 245, 249, 0.8)",
            backdropFilter: "blur(20px)",
            borderRadius: 1.5,
            borderBottom: "1px solid rgb(241 245 249)",
            padding: "12px 24px",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                sx={{
                    width: { xs: 40, sm: 64 },
                    height: { xs: 58, sm: 82 },
                    borderRadius: 1.5,
                    background: "rgba(255, 255, 255, 0.3)",
                    backdropFilter: "blur(4px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0.5,
                    position: "relative",
                }}
                >
                <Box
                    component="img"
                    src={image ?? defaultMiniature}
                    alt={t("digitizedDocument")}
                    sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 0.5,
                    }}
                />
                {origin === "External" && (
                    <div
                    style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        padding: "0.25rem",
                        borderRadius: "50%",
                    }}
                    >
                    <img src={api} alt="API" style={{ maxWidth: "1.5rem" }} />
                    </div>
                )}
                </Box>

                <Box>
                <Typography
                    variant="h4"
                    sx={{
                    fontWeight: 700,
                    color: "grey.900",
                    mb: 0.5,
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    }}
                >
                    {isOCRCompleted ? (
                    <Tooltip title={t("openEditor")}>
                        <Box
                        component="a"
                        sx={{
                            cursor: "pointer",
                            textDecoration: "none",
                            color: "inherit",
                        }}
                        onClick={() => openTheEditor(id, lang)}
                        >
                        <Highlighter
                            searchWords={[searchText]}
                            textToHighlight={title.length > 60 ? `${title.substring(0, 60)}...` : title}
                        />
                        </Box>
                    </Tooltip>
                    ) : (
                    <Highlighter
                        searchWords={[searchText]}
                        textToHighlight={title.length > 60 ? `${title.substring(0, 60)}...` : title}
                    />
                    )}
                    <Box sx={{ display: "flex", alignItems: "center", ml: 1, gap: 1 }}>
                    {controller.profileData.id === digitizerId && (
                        <Tooltip title={t("edit")}>
                        <IconButton
                            size="small"
                            sx={{
                            ml: 1,
                            color: "grey.700",
                            padding: 0.5,
                            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                            }}
                            onClick={handleOpenMetadataDialog}
                        >
                            <Edit sx={{ fontSize: "16px" }} />
                        </IconButton>
                        </Tooltip>
                    )}
                    {status === "ERROR" && !rerunDigitization && (
                        <Box>{getStatusIcon('FAILED', lang)}</Box>
                    )}
                    {((status === "COMPLETE" && stepsData.some(service => service.service_status === 'IN_PROGRESS')) ||
                        (status != "COMPLETE" && status != "ERROR" && status != "PENDING") ||
                        rerunDigitization === true) && (
                        <MyTimer expiryTimestamp={approximateEndTime} isSmallScreen={isSmallScreen} t={t} />
                    )}
                    </Box>
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    📅
                    <Typography
                    variant="body2"
                    sx={{
                        color: "grey.600",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                    }}
                    >
                    {formattedCreatedAt}
                    </Typography>
                </Box>

                {feedback_rating !== null && feedback_rating !== undefined && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                    {Array(feedback_rating).fill().map((_, index) => (
                        <MdStarRate key={index} style={{ color: "#fbbf24", fontSize: "16px" }} />
                    ))}
                    </Box>
                )}
                </Box>
            </Box>

            {!isSmallScreen && (
                <Box
                className="desktop-action-buttons"
                sx={{
                    display: "flex",
                    gap: 1,
                    opacity: 0,
                    transition: "opacity 0.2s ease",
                }}
                >
                <Tooltip title={t("downloadDigitizedArticle")}>
                    <span>
                        <IconButton
                        size="small"
                        onClick={() => handleClickDownloadDigitizedDocument()}
                        sx={{
                            width: 36,
                            height: 36,
                            p: 0,
                            bgcolor: "rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(4px)",
                            border: "1px solid rgba(255, 255, 255, 0.1)",
                            borderRadius: 1,
                            "&:hover": {
                            bgcolor: "rgba(255, 255, 255, 0.3)",
                            },
                        }}
                        disabled={status !== "COMPLETE"}
                        >
                            <Download sx={{ fontSize: 16 }} />
                        </IconButton>
                    </span>
                </Tooltip>

                {!all_services_selected && (
                    <Tooltip title={t("runNonExecutedServices")}>
                        <IconButton
                            size="small"
                            onClick={() => setOpenRunNonExecutedServicesDialog(true)}
                            sx={{
                                width: 36,
                                height: 36,
                                p: 0,
                                bgcolor: "rgba(255, 255, 255, 0.2)",
                                backdropFilter: "blur(4px)",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                borderRadius: 1,
                                "&:hover": {
                                    bgcolor: "rgba(255, 255, 255, 0.3)",
                                },
                            }}
                        >
                            <Settings sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                )}

                {status === "ERROR" && !rerunDigitization && (
                    <Tooltip title={t("rerunDigitization")}>
                    <IconButton
                        size="small"
                        onClick={handleRerunDigitization}
                        sx={{
                        width: 36,
                        height: 36,
                        p: 0,
                        bgcolor: "rgba(255, 255, 255, 0.2)",
                        backdropFilter: "blur(4px)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        borderRadius: 1,
                        "&:hover": {
                            bgcolor: "rgba(255, 255, 255, 0.3)",
                        },
                        }}
                    >
                        <Refresh sx={{ fontSize: 16 }} />
                    </IconButton>
                    </Tooltip>
                )}

                {(controller.role === SUPER_ADMIN_ROLE || controller.userId === digitizerId) && (
                    <Tooltip title={t("deleteArticle")}>
                    <IconButton
                        size="small"
                        onClick={handleOpenDeleteDialog}
                        sx={{
                        width: 36,
                        height: 36,
                        p: 0,
                        bgcolor: "rgba(255, 255, 255, 0.2)",
                        backdropFilter: "blur(4px)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        borderRadius: 1,
                        "&:hover": {
                            bgcolor: "rgba(244, 67, 54, 0.1)",
                            color: "error.main",
                        },
                        }}
                    >
                        <Delete sx={{ fontSize: 16 }} />
                    </IconButton>
                    </Tooltip>
                )}
                </Box>
            )}

            {isSmallScreen && (
                <>
                <Tooltip title={t("actions")}>
                    <IconButton
                    sx={{
                        width: 40,
                        height: 40,
                        bgcolor: "rgba(255, 255, 255, 0.2)",
                        backdropFilter: "blur(4px)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        borderRadius: 1,
                        "&:hover": {
                        bgcolor: "rgba(255, 255, 255, 0.3)",
                        },
                    }}
                    onClick={handleActionMenuOpen}
                    >
                    <MoreVert sx={{ fontSize: 20, color: "grey.700" }} />
                    </IconButton>
                </Tooltip>

                <Menu
                    anchorEl={actionMenuAnchor}
                    open={Boolean(actionMenuAnchor)}
                    onClose={handleActionMenuClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    PaperProps={{
                    sx: {
                        background: "rgba(255, 255, 255, 0.9)",
                        backdropFilter: "blur(20px)",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                        borderRadius: 2,
                        boxShadow: "0 10px 25px -5px rgb(0 0 0 / 0.25)",
                        minWidth: 160,
                        mt: 1,
                    },
                    }}
                >
                    {controller.profileData.id === digitizerId && (
                    <MenuItem
                        onClick={() => {
                        handleOpenMetadataDialog();
                        handleActionMenuClose();
                        }}
                        sx={{
                        py: 1.5,
                        px: 2,
                        "&:hover": { bgcolor: "rgba(237,237,237,0.76)" },
                        }}
                    >
                        <Edit sx={{ fontSize: 18, color: "primary.main", mr: 2 }} />
                        <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: "grey.800" }}>
                        {t("edit")}
                        </Typography>
                    </MenuItem>
                    )}

                    {status === "ERROR" && !rerunDigitization && (
                    <MenuItem
                        onClick={() => {
                        handleRerunDigitization();
                        handleActionMenuClose();
                        }}
                        sx={{
                        py: 1.5,
                        px: 2,
                        "&:hover": { bgcolor: "rgba(237,237,237,0.76)" },
                        }}
                    >
                        <Refresh sx={{ fontSize: 18, color: "primary.main", mr: 2 }} />
                        <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: "grey.800" }}>
                        {t("rerunDigitization")}
                        </Typography>
                    </MenuItem>
                    )}

                    <MenuItem
                    onClick={() => {
                        handleClickDownloadDigitizedDocument();
                        handleActionMenuClose();
                    }}
                    disabled={status !== "COMPLETE"}
                    sx={{
                        py: 1.5,
                        px: 2,
                        "&:hover": { bgcolor: "rgba(237,237,237,0.76)" },
                    }}
                    >
                    <Download sx={{ fontSize: 18, color: "primary.main", mr: 2 }} />
                    <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: "grey.800" }}>
                        {t("downloadDigitizedArticle")}
                    </Typography>
                    </MenuItem>


                    {!all_services_selected && (
                        <MenuItem
                            onClick={() => {
                                setOpenRunNonExecutedServicesDialog(true);
                                handleActionMenuClose();
                            }}
                            disabled={!isRunNonExecutedServicesButtonEnabled}
                            sx={{
                                py: 1.5,
                                px: 2,
                                "&:hover": {bgcolor: "rgba(237,237,237,0.76)"},
                            }}
                        >
                            <ListItemIcon sx={{minWidth: 36}}>
                                <Settings style={{fontSize: 18, color: "default"}}/>
                            </ListItemIcon>
                            <ListItemText
                                primary={t("runNonExecutedServices")}
                                sx={{
                                    "& .MuiListItemText-primary": {
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        color: "grey.800",
                                    },
                                }}
                            />
                        </MenuItem>
                    )}
                </Menu>
                </>
            )}
            </Box>
        </Box>

        {/* Status indicators (stepper) */}
        <Box sx={{ margin: '5px', display: 'flex', justifyContent: 'center', width: '100%' }}>
            {((status === "COMPLETE" && stepsData.some(service => service.service_status === 'ERROR' || service.service_status === 'IN_PROGRESS')) ||
            (status != "COMPLETE" && status != "ERROR" && status != "PENDING") ||
            (rerunDigitization === true)) && origin === "Internal" && (
            <StepperStatusComponent
                stepsData={stepsData}
                handleRerunService={handleRerunService}
                handleSkipService={handleSkipService}
            />
            )}
        </Box>

        {/* Main Content Section */}
        <CardContent
            sx={{
            background: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(8px)",
            padding: "16px 24px",
            }}
        >
            <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                gap: { xs: 3, lg: 4 },
            }}
            >
            {/* Left column - Document details */}
            <Box sx={{ flex: "2", minWidth: 0 }}>
                <Stack spacing={2}>
                {/* Author and Published Date */}
                <Stack spacing={2.5}>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                    <Typography
                        variant="body2"
                        sx={{
                        fontWeight: 600,
                        color: "grey.700",
                        minWidth: 80,
                        fontSize: "0.875rem",
                        }}
                    >
                        {t("author")}:
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                        fontWeight: 600,
                        color: "grey.900",
                        fontSize: "0.875rem",
                        }}
                    >
                        {author && <Highlighter searchWords={[searchText]} textToHighlight={author} />}
                    </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                    <Typography
                        variant="body2"
                        sx={{
                        fontWeight: 600,
                        color: "grey.700",
                        minWidth: 80,
                        fontSize: "0.875rem",
                        }}
                    >
                        {t("published")}:
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                        fontWeight: 500,
                        color: "grey.900",
                        fontSize: "0.875rem",
                        }}
                    >
                        {publishedAt && <Highlighter searchWords={[searchText]} textToHighlight={publishedAt} />}
                    </Typography>
                    </Box>
                </Stack>

                {/* Summary */}
                {summary && (
                    <Stack spacing={1.5}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 600,
                            color: "grey.700",
                            fontSize: "0.875rem",
                        }}
                        >
                        {t("summary")}:
                        </Typography>
                        <Typography
                        component="div"
                        variant="body2"
                        color="grey.900"
                        sx={{
                            lineHeight: 1.6,
                            textAlign: "justify",
                            fontSize: "0.875rem",
                        }}
                        >
                        <ReactReadMoreReadLess
                            charLimit={isSmallScreen ? 200 : 400}
                            readMoreText={t("readMore")}
                            readLessText={t("readLess")}
                        >
                            {summary}
                        </ReactReadMoreReadLess>
                        </Typography>
                    </Box>
                    </Stack>
                )}

                {/* Subject Tags */}
                {subjects?.length > 0 && (
                    <Stack spacing={2}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 600,
                            color: "grey.700",
                            fontSize: "0.875rem",
                        }}
                        >
                        {t("subjects")}
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {subjects.map((subject, idx) => (
                            <Box
                            key={idx}
                            sx={{
                                backgroundColor: '#eff6ff',
                                borderColor: '#bfdbfe',
                                color: 'black',
                                fontSize: "0.75rem",
                                height: 28,
                                fontWeight: 400,
                                paddingX: 1.2,
                                borderRadius: "10px",
                                display: "inline-flex",
                                alignItems: "center",
                                transition: 'background-color 0.3s ease',
                                '&:hover': {
                                backgroundColor: '#dbeafe',
                                },
                            }}
                            >
                            {subject}
                            </Box>
                        ))}
                        </Box>
                    </Box>
                    </Stack>
                )}

                {/* Services */}
                <Stack spacing={1.5}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography
                        variant="body2"
                        sx={{
                        fontWeight: 600,
                        color: "grey.700",
                        fontSize: "0.875rem",
                        }}
                    >
                        {t("services")}
                    </Typography>
                    <ServicesIconsGroup stepsData={stepsData} />
                    </Box>
                </Stack>
                </Stack>
            </Box>

            {/* Payment Details Section - Only for FREE_AGENT */}
            {controller.role === FREE_AGENT && (
                <Box
                sx={{
                    flex: { xs: "none", lg: "1" },
                    minWidth: { xs: "100%", lg: 220 },
                    maxWidth: { lg: 380 },
                    width: { xs: "100%", lg: "auto" },
                }}
                >
                <Card
                    sx={{
                    background: "rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(20px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    borderRadius: 1.5,
                    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                    height: "fit-content",
                    }}
                >
                    <CardContent sx={{ p: 2.5 }}>
                    <Typography
                        variant="h6"
                        sx={{
                        fontWeight: 700,
                        color: "grey.900",
                        mb: 2,
                        pb: 1,
                        borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                        fontSize: "1.125rem",
                        }}
                    >
                        {t("PaymentDetails")}
                    </Typography>

                        <Stack spacing={2}>
                            {/* Payment Amounts */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: 500,
                                            color: "grey.700",
                                            fontSize: "0.875rem",
                                        }}
                                    >
                                        {pendingServices.length > 0 ? t("paymentAmount") : t("AmountPaid")}:
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: "bold",
                                            color: pendingServices.length > 0 ? "#dd6b20" : "#0c1121",
                                        }}
                                    >
                                        ${parseFloat(pendingServices.length > 0 ? pendingProcessesCost : CompletedProcessesCost).toFixed(2)}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Pending Services */}
                            {pendingServices.length > 0 && digitizationProcesses.length > 1 && (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                    {pendingServices.map(service => (
                                        <Chip
                                            key={service.id}
                                            label={service.name}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#eff6ff',
                                                borderColor: '#bfdbfe',
                                                color: 'black',
                                                fontSize: "0.75rem",
                                                height: 28,
                                                fontWeight: 400,
                                                paddingX: 1.2,
                                                borderRadius: "10px",
                                                transition: 'background-color 0.3s ease',
                                                '&:hover': {
                                                    backgroundColor: '#dbeafe',
                                                },
                                            }}
                                            deleteIcon={<CancelIcon sx={{ fontSize: 16, color: "#007bff" }} />}
                                            onDelete={() => handleDeletePendingService(service.id)}
                                        />
                                    ))}
                                </Box>
                            )}

                            <Divider sx={{ bgcolor: "rgba(255, 255, 255, 0.2)", my: 1.5 }} />

                            {/* Payment Buttons */}
                            {hasPendingProcess && (
                                <div>
                                    {!hasSufficientCredits ? (
                                        parseFloat(pendingProcessesCost) >= 0.5 ? (
                                            <>
                                                <PayPalScriptProvider
                                                    options={{"client-id":  window?.appConfig?.REACT_APP_PAYPAL_CLIENT_ID || process.env.REACT_APP_PAYPAL_CLIENT_ID}}
                                                >
                                                    <PayPalButtons
                                                        style={{ layout: "vertical", label: 'pay', height: 40, borderRadius: 6, color:'white', disableMaxWidth: true }}
                                                        fundingSource={FUNDING.PAYPAL}
                                                        createOrder={() => createOrder(pendingProcessIds, 'paypal').then(res => res.data.id)}
                                                        onApprove={(data) => captureOrder(data.orderID).then(() => {
                                                            setNotification({ show: true, snackbarMessage: t("paymentSuccess"), severity: "success" });
                                                            refreshList();
                                                        })}
                                                    />
                                                </PayPalScriptProvider>

                                                {activeCreditCard && (

                                                    <CreditCardPaymentButton
                                                        articleId={articleId}
                                                        refreshList={refreshList}
                                                        setNotification={setNotification}
                                                        cost={parseFloat(pendingProcessesCost).toFixed(2)}
                                                        processIds={pendingProcessIds}
                                                    />

                                                )}
                                            </>
                                        ) : (
                                            <Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 700, fontSize: '0.85rem' }}>
                                                <TiWarning style={{ marginRight: 6, fontSize: '1rem' }} />
                                                {t("minimumAmountRequired", { amount: "$0.50" })}
                                            </Box>
                                        )
                                    ) : (
                                        <CreditsPaymentButton
                                            articleId={articleId}
                                            refreshList={refreshList}
                                            setNotification={setNotification}
                                            processIds={pendingProcessIds}
                                        />
                                    )}
                                </div>
                            )}
                        </Stack>
                    </CardContent>
                </Card>
                </Box>
            )}

            {/* Super Admin Cost Display */}
            {freeAgentDocuments && controller.role === SUPER_ADMIN_ROLE && (
                <Box
                sx={{
                    flex: { xs: "none", lg: "1" },
                    minWidth: { xs: "100%", lg: 220 },
                    maxWidth: { lg: 380 },
                    width: { xs: "100%", lg: "auto" },
                }}
                >
                <Card
                    sx={{
                    background: "rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(20px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    borderRadius: 1.5,
                    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                    height: "fit-content",
                    }}
                >
                    <CardContent sx={{ p: 2.5 }}>
                    <Typography
                        variant="h6"
                        sx={{
                        fontWeight: 700,
                        color: "grey.900",
                        mb: 2,
                        pb: 1,
                        borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                        fontSize: "1.125rem",
                        }}
                    >
                        {t("PaymentDetails")}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 500,
                            color: "grey.700",
                            fontSize: "0.875rem",
                        }}
                        >
                        {t("AmountPaid")}:
                        </Typography>
                        <Typography
                        variant="h6"
                        sx={{
                            fontWeight: "bold",
                            color: "#0c1121",
                        }}
                        >
                        ${parseFloat(cost).toFixed(2)}
                        </Typography>
                    </Box>
                    {paymentStatus === "COMPLETED" && (
                        <Tooltip title={t("paymentSuccessful")}>
                        <IconButton aria-label="payment status" color="success">
                            <BsCash />
                        </IconButton>
                        </Tooltip>
                    )}
                    {paymentStatus === "FAILED" && (
                        <Tooltip title={t("paymentError")}>
                        <IconButton aria-label="payment status" color="error">
                            <BsCash />
                        </IconButton>
                        </Tooltip>
                    )}
                    {(paymentStatus === null || paymentStatus.toLowerCase() === "pending") && (
                        <Tooltip title={t("paymentPending")}>
                        <IconButton aria-label="payment status" color="default">
                            <BsCash />
                        </IconButton>
                        </Tooltip>
                    )}
                    </CardContent>
                </Card>
                </Box>
            )}
            </Box>
        </CardContent>

                {/* Footer Section */}
                <Box
                    sx={{
                        background: "rgba(255, 255, 255, 0.15)",
                        backdropFilter: "blur(20px)",
                        borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                        p: 3,
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {(status === "FAILED" || status === "COMPLETE") &&
                            controller.role === "free-agent" && !feedback_rating && (
                                <Button
                                    startIcon={<Feedback style={{
                                        marginRight: dir === 'ltr' ? '6px' : '0',
                                        marginLeft: dir === 'rtl' ? '6px' : '0',
                                    }} />}
                                    onClick={() => setShowFeedback(true)}
                                    sx={{
                                        color: "#344767 !important",
                                        fontWeight: 600,
                                        backdropFilter: "blur(4px)",
                                        "&:hover": {
                                            color: "#344767 !important",
                                            bgcolor: "rgba(255, 255, 255, 0.2)",
                                        },
                                    }}
                                >
                                    {t("submitFeedback")}
                                </Button>
                            )}

                    </Box>
                </Box>

                {/* Dialogs */}
                {openDeleteDialog && (
                    <DeleteArticleDialog isModalOpen={openDeleteDialog} handleCloseModal={handleCloseDeleteDialog}
                                        articleId={articleId} articleTitle={title} refreshArticles={refreshList}
                                        setNotification={setNotification}/>
                )}

                {!all_services_selected && isRunNonExecutedServicesButtonEnabled && <RunNonExecutedServices
                    id={id}
                    sourceLanguage={sourceLanguage}
                    targetLanguage={targetLanguage}
                    open={openRunNonExecutedServicesDialog}
                    onClose={() => {
                        setOpenRunNonExecutedServicesDialog(false)
                    }}
                    refreshList={refreshList}
                    setNotification={setNotification}
                />}

                <EditDigitizedArticleDialog
                    open={isMetadataDialogOpen}
                    onClose={handleCloseMetadataDialog}
                    author={author}
                    title={title}
                    subjects={subjects}
                    publishedAt={publishedAt}
                    sourceLanguage={sourceLanguage}
                    targetLanguage={targetLanguage}
                    digitizationId={id}
                    setNotification={setNotification}
                    refreshList={refreshList}
                />

                {showFeedback &&
                    <FeedbackDialog
                        showFeedback={showFeedback}
                        setShowFeedback={setShowFeedback}
                        digitizationId={id}
                        refreshList={refreshList}
                    />
                }
            </Card>
    );
};

// Typechecking props for the BasicLayout
CardItem.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  summary: PropTypes.string,
  author: PropTypes.string,
  origin: PropTypes.string,
  sourceLanguage: PropTypes.string,
  targetLanguage: PropTypes.string,
  digitizationStartedAt: PropTypes.string,
  image: PropTypes.string,
  status: PropTypes.string,
  paymentStatus: PropTypes.string,
  freeAgentDocuments: PropTypes.bool,
  all_services_selected: PropTypes.bool,
  cost: PropTypes.string,
  publishedAt: PropTypes.node,
  handleOpenPreview: PropTypes.func,
  createdAt: PropTypes.string,
  searchText: PropTypes.string,
  handleClickDownloadDigitizedDocument: PropTypes.func,
  subjects: PropTypes.array,
  services_data: PropTypes.array,
  setNotification: PropTypes.func,
  refreshList: PropTypes.func,
  articleId: PropTypes.number,
  digitizerId: PropTypes.number,
  userCreditBalance: PropTypes.number,
  feedback_rating: PropTypes.number,
  totalApproximativeTime: PropTypes.number,
  digitizationProcesses: PropTypes.array,
  pendingProcessesCost: PropTypes.number,
  CompletedProcessesCost: PropTypes.number,
};
export default CardItem;
